import { render, staticRenderFns } from "./userContent.vue?vue&type=template&id=33b4842a&scoped=true&"
import script from "./userContent.vue?vue&type=script&lang=js&"
export * from "./userContent.vue?vue&type=script&lang=js&"
import style0 from "./userContent.vue?vue&type=style&index=0&id=33b4842a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33b4842a",
  null
  
)

export default component.exports